import * as React from 'react';
import { Checkbox, Surface, Text } from '@/components/ui';
import { Form, FormField } from '@/components/business';

export function TermsForm ({ form }) {
    return (
        <div className="tw-flex tw-flex-col tw-gap-4">
            <Surface tone="muted">
                <Text variant="body-sm">{i18next.t('terms.effective_date')}</Text>
                <br/>
                {Object.entries(i18next.t('terms.chapters', { returnObjects: true }))
                    .sort(([left], [right]) => Number(left) - Number(right))
                    .map(([key, chapter]) => (
                        <React.Fragment key={key}>
                            <div className="tw-mt-2">
                                <Text variant="body-sm"><strong>{chapter.title}</strong></Text>
                            </div>
                            <Text variant="body-sm">{chapter.text}</Text>
                            {chapter.extra && (
                                <ul className="tw-list-disc tw-ml-4 tw-space-y-1 tw-clear-float-list">
                                    {Object.values(chapter.extra).map((item, i) => (
                                        <li key={i}><Text variant="body-sm">{item}</Text></li>
                                    ))}
                                </ul>
                            )}
                            <br/>
                        </React.Fragment>
                    ))}
            </Surface>
            <Form form={form}>
                <FormField name="acceptedTerms"
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            onCheckedChange={field.onChange}
                            label={i18next.t('terms.accept_terms')}
                        />
                    )}
                />
                <FormField name="marketing"
                    render={({ field }) => (
                        <Checkbox
                            checked={field.value}
                            onCheckedChange={field.onChange}
                            label={i18next.t('terms.marketing_opt_in')}
                        />
                    )}
                />
            </Form>
        </div>
    );
}
